<template>
    <div id="productPaging" class="pager default text-center"></div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    export default {
        methods: {
            createPaging(totalDataCount, pageNumber) {
                var createQueryStringParameterDelegate = function (pageNum) {
                    filterEventBus.$emit('createQueryStringParameter', pageNum);
                }
                $(function () {
                    try {
                        $('#productPaging').pagination('destroy');
                    } catch  { }
                    var dataSource = [];
                    for (var i = 1; i <= totalDataCount; i++)
                        dataSource.push(i);
                    if (dataSource != null && dataSource.length > 0) {
                        var container = $('#productPaging').pagination({
                            dataSource: dataSource,
                            pageSize: 12,
                            pageNumber: pageNumber,
                            classPrefix: 'pager',
                            ulClassName: 'pager-items',
                            activeClassName: 'is-active',
                        });
                        container.addHook('afterPaging', function () {
                            var pageNum = container.pagination('getSelectedPageNum')
                            createQueryStringParameterDelegate(pageNum);
                        });
                    }
                });
            }, 
        },
        created() {
            filterEventBus.$on('createPaging', (totalDataCount, pageNumber) => {
                this.createPaging(totalDataCount, pageNumber);
            });
        },
        beforeDestroy() {
            filterEventBus.$off('createPaging');
        }
    }
</script>

<style scoped>
</style>